import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Lottie from "lottie-react";
import Cancel from "../../core/data/img/cancel.json";


const PaymentCancel = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate(routes.userBookings);
    }, 2000);
  }, []);

  return (
    <div>

      <div className="d-flex justify-content-center align-items-center">
        <Lottie animationData={Cancel} loop={true} style={{ width: 300, height: 300 }} />
        <p className="text-danger fw-bold fs-4 mt-3 text-center">Payment Failed</p>
        <p className="text-muted text-center">Your payment could not be processed. Please try again or contact support if the issue persists.</p>
      </div>


    </div>
  )
}

export default PaymentCancel